module.exports = __webpack_public_path__ + "static/media/Sampon_na_vlasy_s_Omega369_retina.d807ecb1.jpg";